import * as BABYLON from "babylonjs";
import * as _ from "lodash";

export class VectorUtils {
    static toVector2(v3: BABYLON.Vector3): BABYLON.Vector2 {
        return new BABYLON.Vector2(v3.x, v3.y);
    }

    static toVector3(v2: BABYLON.Vector2): BABYLON.Vector3 {
        return new BABYLON.Vector3(v2.x, v2.y, 0);
    }

    static toNumberArray(vectors: BABYLON.Vector3[]): number[] {
        return _.flatMap(vectors, it => it.asArray());
    }

    static slerp(start: BABYLON.Vector3, end: BABYLON.Vector3, percent: number): BABYLON.Vector3 {
        let h1 = start.length();
        let h2 = end.length();
        let v1 = start.scale(1.0 / h1);
        let v2 = end.scale(1.0 / h2);
        let dot = BABYLON.Vector3.Dot(v1, v2);
        dot = Math.max(Math.min(dot, 1.0), -1.0);
        let theta = Math.acos(dot) * percent;
        let relativeVec = v2.add(v1.scale(-dot));
        relativeVec.normalize();
        let h = h1 * (1 - percent) + h2 * percent;
        return v1.scale(Math.cos(theta)).add(relativeVec.scale(Math.sin(theta))).scale(h);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/core/vectorUtils.ts